export default (initialState = {}) => {
  return () => {
    return {
      credit_ratings: [
        {
          agency: null,
          rating: null,
          ranking: null,
          available: null,
          rating_source_link: "",
          rating_added_date: null,
        },
      ],
      legal_cases: null,
      credit_eligibility: null,
      credit_limit: null,
      negative_due_diligence: null,
      direct_indirect_grade: "",
      ...initialState,
    };
  };
};
